import {InjectionToken} from '@angular/core'
import {OrderLineService} from '@service/orders/order-lines/orderLine.service'
import {OrderLinesEmbeddedService} from '@service/orders/order-lines/orderLines-embedded.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `OrderLineService`.
 *
 * @description
 * Devuelve `OrderLinesEmbeddedService` en modo embebido y
 * `OrderLineService` en modo standalone. `OrderLineService` encapsula la
 * creación, actualización y eliminación de líneas de un pedido, así como
 * la lógica de conversión entre unidades de medida.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `OrderLineService`.
 */
export function providerOrderLinesFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new OrderLinesEmbeddedService() : new OrderLineService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `OrderLineService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerOrderLinesFactory}.
 */
export const OrderLinesServiceToken = new InjectionToken<OrderLineService>('OrderLinesService')
